import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { JOB_STATES, RUN_TYPES } from '~/features/content/utils/content-jobs';

// The keys the old Jobs page read; its `tab` becomes the Runs `type` filter.
const searchSchema = z.object({
  tab: z.enum(RUN_TYPES).optional().catch(undefined),
  state: z.enum(JOB_STATES).optional().catch(undefined),
});

/**
 * `/content/jobs` was the old name of Runs — kept as a redirect to `/content/runs` so saved links
 * and bookmarks still land, with `tab` mapped to `type` and `state` carried over.
 */
export const Route = createFileRoute('/_authenticated/_tenant/content/jobs')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({
      to: '/content/runs',
      search: {
        ...(search.tab && { type: search.tab }),
        ...(search.state && { state: search.state }),
      },
      replace: true,
    });
  },
});
